<ng-container *ngIf="currentFile; else noFound">
  <div class="wrapper wrapper-content">
    <section class="w-100 pl-4 pr-4">
      <ng-container *ngIf="isPdf; else noFound">
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="signatureToolForm">
              <form [formGroup]="signatureToolForm">
                <label [innerHTML]="'SignatureTool.comment' | translate">
                </label>
                <signature-tool-dropdown
                  formControlName="selectedComment"
                  [resetValue]="valueDropdown"
                  [placeholder]="'SignatureTool.placeholder' | translate"
                ></signature-tool-dropdown>
                <plyca-ui-textarea
                  formControlName="comment"
                  [maxLength]="200"
                ></plyca-ui-textarea>
              </form>
            </ng-container>
          </div>
          <div
            [ngClass]="{
            'd-col-12 col-md-9': currentFile.signatures.length > 0,
            'col-12': currentFile.signatures.length === 0
            }"
          >
            <filePDFViewer
              #viewer
              [currentFile]="currentFile"
              [showZoom]="true"
              [showPages]="true"
              [showToolbar]="true"
              [showRotation]="true"
              [showAllPagesDocument]="false"
            >
            </filePDFViewer>
          </div>
          <ng-container *ngIf="currentFile.signatures.length > 0">
            <div class="d-col-12 col-md-3">
              <div class="signature-accordion">
                <signature-tool-accordion
                  [file]="currentFile"
                  [signaturesList]="signaturesList"
                ></signature-tool-accordion>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </section>
  </div>
</ng-container>
<ng-template #noFound>
  <section class="wrapper wrapper-content">
    <div class="row">
      <div class="col-12">
        <signature-tool-alert
          [fileAdded]="isFileAdded"
          [isPdf]="isPdf"
        ></signature-tool-alert>
        <upload-files
          [files]="[]"
          [documentClass]="documentClass"
          (addItem)="addFile($event)"
        ></upload-files>
      </div>
    </div>
  </section>
</ng-template>
